import { Component } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';



@Component({
  selector: 'ngx-three-columns-layout',
  styleUrls: ['./three-columns.layout.scss'],
  template: `
    <nb-layout windowMode>
      
    <nb-sidebar class="menu-sidebar" state="compacted" tag="menu-sidebar" responsive>
      <div class="sidebar-logo">
        <div class="d-flex align-items-center h-50sidebar">

          <a class="logo" href="#" (click)="$event.preventDefault()">

          <img src="assets/images/MDB_LOGO.png" alt="osrtc logo"/>   
          </a>
          <a (click)="toggleSidebar()" href="#" class="sidebar-toggle ml-auto">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
      </div>  
      <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="small">
      </nb-layout-column>

      <nb-layout-column>
      <nb-layout-header fixed>
      <ngx-header></ngx-header>
      </nb-layout-header>
  
      <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-column class="small">
      </nb-layout-column>

      <nb-layout-footer fixed>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class ThreeColumnsLayoutComponent {
  constructor(private sidebarService: NbSidebarService, private layoutService: LayoutService) { }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }
}
